import { OverlayRef } from '@angular/cdk/overlay';
import { computed, inject, Injectable } from '@angular/core';
import { ExpertEventNotificationRecord } from '@libs/shared/api';
import { injectCoreFeature } from '@sprint-expert/app/core/state/core.service';

@Injectable()
export class ExpertEventNotificationService {
  private readonly core = injectCoreFeature();

  readonly slice$$ = this.core.eventNotificationSlice$$;
  readonly pageQuery$$ = this.core.eventNotificationPageQuery$$;
  readonly isLoading$$ = this.core.eventNotificationIsLoading$$;
  readonly isLoaded$$ = this.core.eventNotificationIsLoaded$$;
  readonly error$$ = this.core.eventNotificationErrorMessage$$;
  readonly unreadCount$$ = this.core.eventNotificationUnreadCount$$;
  readonly showOnlyUnread$$ = computed(
    () => this.pageQuery$$().filter?.read === false
  );

  readonly currentExpertWorkspace$$ = this.core.currentExpertWorkspace$$;

  overlayRef: OverlayRef;

  fetchExpertEventNotificationSlice = () =>
    this.core.fetchExpertEventNotificationSlice();

  fetchNextExpertEventNotificationSlice = () => {
    if (!this.slice$$() || this.slice$$().last) return;
    this.core.fetchNextExpertEventNotificationSlice();
  };

  fetchExpertEventNotificationById = (id: string) =>
    this.core.fetchExpertEventNotificationById(id);

  activateExpertEventNotification = (id: string) =>
    this.core.activateExpertEventNotification(id);

  inactivateExpertEventNotification = (id: string) =>
    this.core.inactivateExpertEventNotification(id);

  toggleExpertEventNotification = (item: ExpertEventNotificationRecord) => {
    return item.readAt
      ? this.core.unreadExpertEventNotification(item.id)
      : this.core.readExpertEventNotification(item.id);
  };

  readExpertEventNotification = (item: ExpertEventNotificationRecord) => {
    if (item.readAt) return;
    this.core.readExpertEventNotification(item.id);
  };

  toggleShowOnlyUnreadExpertEventNotifications(checked: boolean) {
    this.core.updateExpertEventNotificationPageQuery({
      ...this.pageQuery$$().filter,
      read: checked ? false : undefined,
    });
  }
  readAllExpertEventNotifications() {
    this.core.readAllExpertEventNotifications(this.core.currentUser$$().id);
  }

  closePanel(): void {
    this.overlayRef.detach();
  }
}

export function injectExpertEventNotificationService() {
  return inject(ExpertEventNotificationService);
}

export function provideExpertEventNotificationService() {
  return [ExpertEventNotificationService];
}
